import React from 'react';

/** Triangle shape to put under the WarningIndicator icon to turn the inside part, (!) the correct color. */
const TriangleUnderlaySvg = React.forwardRef<SVGSVGElement, { theme: any }>((props, ref) => {
  const { theme } = props;
  const underlayFill = theme.BUTTON.warning.icon;
  return (
    <div style={{ height: 24, width: 24 }}>
      <svg ref={ref} width="24" height="24" viewBox="0 0 24 24">
        <g id="a">
          <rect y="0" width="24" height="24" fill="none" />
        </g>
        <g id="b">
          <g id="c">
            <g id="d">
              <path d="M12,3L2,21H22L12,3Z" fill={underlayFill} />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
});

TriangleUnderlaySvg.displayName = 'TriangleUnderlaySvg';
export { TriangleUnderlaySvg as default };
